/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const EmailStudentsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('EMAIL_STUDENTS_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class EmailStudentsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EmailStudentsEnabledSettingParser.decode(input).map(res => new EmailStudentsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return EmailStudentsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EmailStudentsEnabledSettingParser.encode(data);
    }
    static schema() {
        return EmailStudentsEnabledSettingParser.schema();
    }
}
